<template>
  <section class="section-slider dark reverse-accent" >
    <div class="container container-small">
      <TextSection :header="headerText" class="header"/>
      <div class="slider">
        <div class="controllers">
          <button
            type="button"
            class="prev"
            @click="showPrev"
            :title="buttonData.prev">
            <svg>
              <use xlink:href="#arrowLeftSvg"></use>
            </svg>
            {{ buttonData.prev }}
          </button>
          <button
            type="button"
            class="next"
            @click="showNext"
             :title="buttonData.next">
            <svg>
              <use xlink:href="#arrowRightSvg"></use>
            </svg>
            {{ buttonData.next }}
          </button>
        </div>
        <div class="slide-wrapper">
          <div class="slide" v-for="(item, index) in items" :key="'item' + index" :class="{
              prev: index == (activeItem - 1 + items.length) % items.length,
              active: index == activeItem,
              next: index == (activeItem + 1) % items.length
            }">
            <template v-if="item.header || item.text">
              <span class="no text-xl">{{ padNumber(index + 1) }}</span>
              <h5 v-if="item.header" class="text-m text-uppercase">{{ item.header }}</h5>
              <p v-if="item.text" class="text-inverted">{{ item.text }}</p>
              <p v-if="item.link && item.link.page" class="text-left">
                <router-link :to="{ name: item.link.page }" :title="item.link.label" :class="{ 'link-icon': item.link.icon }">
                  <span v-if="!item.link.icon">{{ item.link.label }}</span>
                  <svg v-else>
                    <use :xlink:href="'#' + item.link.icon"></use>
                  </svg>
                </router-link>
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'

export default {
  name: 'sliderSection',
  // props: ['items', 'header', 'description'],
  props: ['headers', 'items'],
  components: {
    TextSection
  },
  data: function () {
    return {
      activeItem: 0,
      loop: true,
      loopTimeout: null
    }
  },
  computed: {
    ...mapGetters([
      'buttonData'
    ]),
    headerText () {
      return this.headers && this.headers.length > 0 ? this.headers[0].header : ''
    }
  },
  methods: {
    padNumber (num) {
      var s = String(num)
      while (s.length < 2) {
        s = '0' + s
      }
      return s
    },
    showNext () {
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    }
  },
  mounted () {
    setTimeout(this.loopNext, 4000)
  }
}
</script>

<style scoped lang="scss">
  .section-slider {
    padding: 40px 0 15px;
    position: relative;
    min-height: 190px;
    .container {
      display: flex;
      justify-content: space-between;
      position: relative;
    }
    @include mobile {
      padding: 72px 0 0;
      .container {
        display: block;
        justify-content: initial;
      }
    }
  }
  .header {
    width: 50%;
    max-width: 60vw;
    @include desktop {
      width: 40%;
    }
    @include mobile {
      width: 100%;
      max-width: 100%;
    }
  }
  .no {
    font-weight: 600;
    position: absolute;
    top: 0;
    left: 0;
  }
  .slide {
    align-content: flex-start;
    align-items: flex-start;
    display: none;
    flex-flow: row wrap;
    overflow: hidden;
    opacity: 0;
    padding: 0;
    position: relative;
    transition: $transitionSlider;
    text-align: left;
    width: 0;
    z-index: 1;

    h5, p {
      flex: 0 0 100%;
      margin: 0;
      padding: 0 0 0.25em 0;
      font-weight: 500;
      min-width: 100%;
    }
    p a {
      display: inline-block;
      color: $text-accent !important;

      svg {
        fill: $text-accent;
      }

      &:hover, &:focus {
        color: $contrast-text !important;

        svg {
          fill: $contrast-text;
        }
      }
    }
    .link-icon {
      max-width: 200px;

      svg {
        height: 43px;
        margin: 1em 0 0 -20px;
        width: auto;
        max-width: 100%;
        transition: fill $animation-duration ease-in-out;
      }
    }

    &.prev,
    &.next,
    &.active {
      display: flex;
      min-width: 356px;
      width: 26vw;
      max-width: 600px;
    }
    &.prev,
    &.next {
      bottom: 0;
      height: 100%;
      padding: 12px 0 0 60px;
      position: absolute;
    }
    &.prev {
      left: 0;
      transform: translateX(-100vw);
    }
    &.next {
      left: auto;
      right: 0;
      transform: translateX(100vw);
    }
    &.active {
      transform: translateX(0);
      padding: 12px 0 12px 60px;
      opacity: 1;
    }
    @include mobile {
      &.prev,
      &.next,
      &.active {
        padding: 60px 0 0 0;
        min-width: 100%;
      }
    }
  }
  .controllers {
    position: absolute;
    z-index: 3;
    top: 0;
    // transform: translateY(-50%);
    right: 0;
    width: 86px;
    height: 100%;
    align-items: top;
    @include mobile {
      width: 112px;
      right: auto;
      left: 80px;
      top: 26px;
      height: auto;
    }
    button {
      border: 0;
      background-color: transparent;
      box-shadow: none;
      outline: none;
      padding: 7px;
      &:focus {
        outline: none;
      }
      font-size: 0;
      color: transparent;
      &.prev {
        position: absolute;
        left: 0;
        top: 0;
        // transform: translateY(-50%);
      }
      &.next {
        position: absolute;
        right: 0;
        top: 0;
        // transform: translateY(-50%);
      }
    }
    svg {
      width: 20px;
      height: 20px;
      @include mobile {
        width: 26px;
        height: 26px;
      }
    }
  }
  .slide-wrapper {
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    min-width: 356px;
    width: 26vw;
    max-width: 600px;
    overflow: hidden;
    min-height: 15em;
    height: 100%;
    text-align: left;
    margin-right: 80px;
    // @include desktop {
    //   .font-size-l & {
    //     min-height: 220px;
    //   }
    // }
    @include mobile {
      min-height: 270px;
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin-right: 0;
      top: -32px;
    }
  }
  .slider {
    @include mobile {
      position: relative;
      padding: 60px 0 0;
    }
    /deep/ .accent {
      display: block;
    }
    // position: absolute;
    // z-index: 3;
    // top: 0;
    // right: 0;
    // transform: translateY(-50%);
  }
</style>
